import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { intlReducer } from 'react-intl-redux'

import amazonSellerAccounts from './amazon_seller_accounts'
import account from './account'
import alerts from './alerts'
import amazonStore from './amazon_store'
import analytics from './analytics'
import cardInfo from './card_info'
import chat from './chat'
import checklist from './checklist'
import database from './database'
import deal from './deal'
import extension from './extension'
import globalData from './global'
import historicalData from './historical_data'
import inventory from './inventory'
import keyword from './keyword'
import keywordEngine from './keyword_engine'
import keywordList from './keyword_list'
import keywordProducts from './keyword_products'
import marketInsights from './market_insights'
import product from './product'
import productAlerts from './product_alerts'
import productCosts from './product_costs'
import productInsights from './product_insights'
import registrations from './registrations'
import salesAnalytics from './sales_analytics'
import seats from './seats'
import sessions from './sessions'
import settings from './settings'
import setupWizard from './setup_wizard'
import sidebar from './sidebar'
import subscriptions from './subscriptions'
import supplier from './supplier'
import supplierDatabase from './supplier_database'
import supplierGroup from './supplier_group'
import supplierTracker from './supplier_tracker'
import team from './team'
import tracker from './tracker'
import { rankTrackerV2 } from './rank_tracker_v2'

const staticReducers = {
  amazonSellerAccounts,
  account,
  alerts,
  amazonStore,
  analytics,
  cardInfo,
  chat,
  checklist,
  database,
  deal,
  extension,
  globalData,
  historicalData,
  intl: intlReducer,
  inventory,
  keyword,
  keywordEngine,
  keywordList,
  keywordProducts,
  marketInsights,
  product,
  productAlerts,
  productCosts,
  productInsights,
  registrations,
  salesAnalytics,
  seats,
  sessions,
  settings,
  setupWizard,
  sidebar,
  subscriptions,
  supplier,
  supplierDatabase,
  supplierGroup,
  supplierTracker,
  team,
  tracker,
  rankTrackerV2
}

// Dictionary to keep track of the registered async reducers
const asyncReducers = {}
let cachedHistory

function createRootReducer(history = cachedHistory, overrideReducers = {}) {
  if (history) {
    cachedHistory = history
  }

  return combineReducers({
    router: connectRouter(history),
    ...staticReducers,
    ...asyncReducers,
    ...overrideReducers
  })
}

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
export const injectReducers = (store, reducers) => {
  reducers.forEach(({ key, reducer }) => {
    // don't redefine existing reducers
    if (asyncReducers[key]) {
      return
    }

    asyncReducers[key] = reducer
  })

  store.replaceReducer(createRootReducer())
}

export default createRootReducer
